import type { IdoszakTipus } from './idoszak.ts';

const OPCIOK: readonly { tipus: IdoszakTipus; cim: string }[] = [
  { tipus: '7nap', cim: '7 nap' }, { tipus: '30nap', cim: '30 nap' }, { tipus: 'ez_honap', cim: 'Ez a hónap' },
  { tipus: 'elozo_honap', cim: 'Előző hónap' }, { tipus: 'egyedi', cim: 'Egyedi' },
];

/** Szegmentált időszakválasztó; mobilon a saját sávján belül görgethető. */
export default function IdoszakValaszto({ ertek, onValt }: { ertek: IdoszakTipus; onValt(t: IdoszakTipus): void }) {
  return (
    <div role="group" aria-label="Időszak" className="flex max-w-full gap-1 overflow-x-auto rounded-xl border border-vonal bg-hatter p-1">
      {OPCIOK.map((o) => (
        <button
          key={o.tipus}
          type="button"
          aria-pressed={ertek === o.tipus}
          onClick={() => onValt(o.tipus)}
          className={`min-h-10 shrink-0 whitespace-nowrap rounded-[9px] px-3 text-[13px] transition ${ertek === o.tipus ? 'bg-felulet-2 text-szoveg' : 'text-szoveg-halk hover:text-szoveg'}`}
        >
          {o.cim}
        </button>
      ))}
    </div>
  );
}
